<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">Access Editor</span>
  </div>

  <div class="buttons-block">
    <button class="header-button send-button" mat-button (click)="saveDict()" [disabled]="saveLoading"
            [ngClass]="{'disabled-button': saveLoading}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Title:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="!!tempAccess.id" [(ngModel)]="tempAccess.title">
      </div>
    </div>
    <div class="input-block" *ngIf="!tempAccess.id">
      <div class="input-label">Path:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="!!tempAccess.id" [(ngModel)]="tempAccess.path">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Roles:</div>

      <div class="email-input-text listbox-input">

        <div class="show-all-checkbox" (click)="showAllButtonHeader($event)"
             [ngClass]="{'checked-block': selectedAll}">
          <p-checkbox [(ngModel)]="selectedAll" [binary]="true" inputId="binary" [disabled]="true">
          </p-checkbox>
          <label for="binary">Select All</label>
        </div>

        <p-listbox [options]="allRoles" [(ngModel)]="selectedRoles" [multiple]="true" [checkbox]="true"
                   (onChange)="countRolesMethod()" [showToggleAll]="false" optionLabel="name"
                   [ngModelOptions]="{standalone: true}" class="p-list-box-block">
        </p-listbox>
      </div>
    </div>
  </div>
</div>
